(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("extend"));
	else if(typeof define === 'function' && define.amd)
		define("VueAsset", ["extend"], factory);
	else if(typeof exports === 'object')
		exports["VueAsset"] = factory(require("extend"));
	else
		root["VueAsset"] = factory(root["extend"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition